/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import AdobeExperienceCloud from '@exc/brand-icons/ExperienceCloud';
import AdobeExperiencePlatform from '@exc/brand-icons/ExperiencePlatform';
import AdobeExperienceSubCloud from '@exc/brand-icons/ExperienceSubCloud';
import AdobePrimetime from '@exc/brand-icons/Primetime';
import Icon from '@react/react-spectrum/Icon';
import PropTypes from 'prop-types';
import React from 'react';

const Icons = {
  AdobeExperienceCloud,
  AdobeExperiencePlatform,
  AdobeExperienceSubCloud,
  AdobePrimetime
};

const ColorIcon = ({iconName, iconSize}) => {
  let IconComponent = Icons[iconName] || Icons.AdobeExperienceCloud;
  return <Icon size={iconSize}><IconComponent /></Icon>;
};

ColorIcon.propTypes = {
  enabled: PropTypes.bool,
  iconName: PropTypes.string,
  iconSize: PropTypes.string
};

ColorIcon.defaultProps = {
  enabled: true,
  iconSize: 'XL'
};

export default React.memo(ColorIcon);
